export const getTenant = () => {
  
  const hostname = window.location.hostname;
  
  //отладка на локалхосте либо на тестовом окружении
  if(hostname.startsWith('localhost') || hostname.startsWith('android')) {
    return 'manager';
    //return 'admin';
  }

  if(hostname.startsWith('manager')) {  
    return 'manager';
  }

  if(hostname.startsWith('admin')) {
    return 'admin';
  }

  if(hostname.startsWith('asc')) {
    return 'asc';
  }

  if(hostname.startsWith('client')) {
    return 'client';
  }

  if(hostname.startsWith('vendor')) {
    return 'vendor';
  }

  return null;
};